var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarService = function SvgCarService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#121212",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M19.27 19.35c1.03 0 1.73-.76 1.73-1.88v-2.21c0-.57-.39-1.07-.95-1.21L16 13.04l-1.24-1.53a6.03 6.03 0 0 0-4.67-2.22H4.86c-.85 0-1.64.43-2.1 1.15l-1.2 1.86c-.37.57-.56 1.23-.56 1.91v3.27c0 1.14.74 1.88 1.8 1.88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#121212",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.63 21.536a2.19 2.19 0 1 0 0-4.378 2.19 2.19 0 0 0 0 4.378ZM5 21.536a2.19 2.19 0 1 0 .002-4.378A2.19 2.19 0 0 0 5 21.536Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#121212",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M1.47 13.04h14.54M7.72 19.352h6.57"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M17.36 6.838c0 .83-.68 1.51-1.51 1.51s-1.51-.68-1.51-1.51.68-1.51 1.51-1.51 1.51.68 1.51 1.51Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M17.43 10.69c.08-.12.19-.22.31-.3l.18-.1c.22-.11.48-.15.72-.09l.65.18c.38.11.57.16.74.09s.27-.24.47-.59l.26-.46c.19-.32.28-.48.26-.66-.02-.17-.14-.31-.39-.59l-.55-.61c-.13-.17-.23-.47-.23-.73s.09-.56.23-.73l.55-.61c.25-.28.37-.42.39-.59s-.07-.33-.26-.66l-.26-.46c-.2-.34-.3-.52-.47-.59s-.36-.01-.74.09l-.65.18c-.24.06-.5.02-.72-.09l-.18-.1c-.19-.12-.34-.3-.42-.51l-.18-.53c-.12-.35-.17-.53-.31-.63s-.32-.1-.69-.1h-.59c-.37 0-.55 0-.69.1s-.2.28-.31.63l-.18.53c-.08.21-.23.39-.42.51l-.18.1c-.22.11-.48.15-.72.09l-.65-.18c-.38-.11-.57-.16-.74-.09s-.27.24-.47.59l-.26.46c-.19.32-.28.48-.26.66.02.17.14.31.39.59l.55.61c.13.17.23.47.23.73q0 .195-.06.39"
  })));
};
export default SvgCarService;